import React, { ReactNode } from 'react'
import './Modal.css'

type Props = {
  children: ReactNode
  title: string
}

function Modal(props: Props) {
  const { children, title, ...rest } = props

  return (
    <div className="container" {...rest}>
      <div className="modal">
        <div className="modal-title">
          <b>{title}</b>
        </div>
        <div>
          {children}
        </div>
      </div>
    </div>
  )
}

export default Modal
